<template>
  <div class="no-release">
    <div class="text">{{text}}</div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {};
  },
  computed: {
    text() {
      const obj = {
        editing: "问卷编辑中，点击右上角按钮发布问卷",
        stay: `问卷开始时间为 ${moment(this.data.started_at).format(
          "YYYY年MM月DD日 HH时mm分"
        )}`,
        ended: "问卷已结束"
      };
      return obj[this.data.status] || "";
    }
  }
};
</script>

<style lang="less" scoped>
.no-release {
  margin: 200px auto 0;
  text-align: center;

  .text {
    font-size: 22px;
    margin-bottom: 20px;
  }

  .start-release {
    padding: 12px 40px;
  }
}
</style>
